import { Controller } from "@hotwired/stimulus"

const SCROLL_KEY = "appointments_calendar_scroll_top"

export default class extends Controller {
  static targets = ["scrollable"]

  connect() {
    this.saveScrollHandler = this.saveScroll.bind(this)
    this.restoreScrollHandler = this.restoreScroll.bind(this)
    this.handleTurboLoad = this.handleTurboLoad.bind(this)
    this.element.addEventListener('calendar:save-scroll', this.saveScrollHandler)
    this.element.addEventListener('calendar:restore-scroll', this.restoreScrollHandler)
    window.addEventListener('turbo:load', this.handleTurboLoad)
  }

  disconnect() {
    this.element.removeEventListener('calendar:save-scroll', this.saveScrollHandler)
    this.element.removeEventListener('calendar:restore-scroll', this.restoreScrollHandler)
    window.removeEventListener('turbo:load', this.handleTurboLoad)
  }

  saveScroll() {
    localStorage.setItem(SCROLL_KEY, window.scrollY)
  }

  restoreScroll() {
    // Not needed with localStorage approach, but kept for compatibility
    // Now handled in handleTurboLoad
  }

  handleTurboLoad() {
    const saved = localStorage.getItem(SCROLL_KEY)
    // Always clear the scroll key on every load  
    // Only restore if not a back/forward navigation
    const navEntries = performance.getEntriesByType("navigation")
    if (saved !== null && !(navEntries.length > 0 && navEntries[0].type === "back_forward")) {
      const y = parseInt(saved, 10)
      window.scrollTo({ top: y, behavior: "auto" })
      setTimeout(() => {
        window.scrollTo({ top: y, behavior: "smooth" })
      }, 50)
    }
  }
} 